export default __webpack_public_path__ + "static/media/bnp.449b49dc.png";